export const isValidHttpUrl = (urlString: string) => {
  let url;

  try {
    url = new URL(urlString);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};

export const REGEX_IMAGE_CONTENT_TYPE = /image\/*/g;

export const isValidImageUrl = async (url: string, requestTimeout = 5000) => {
  const abortController = new AbortController();

  try {
    const request = fetch(url, {
      signal: abortController.signal,
    });

    const abortControllerTimeout = setTimeout(() => {
      abortController.abort();
    }, requestTimeout);

    const response = await request;

    clearTimeout(abortControllerTimeout);

    const contentType = response.headers.get('content-type') ?? '';

    return REGEX_IMAGE_CONTENT_TYPE.test(contentType);
  } catch (err) {
    console.error(err);
    return false;
  }
};
